export default __webpack_public_path__ + "static/media/about-page-img.5fef897f.png";